// extracted by mini-css-extract-plugin
export default {"slide":"us46P","carousel-cards":"dxQ0R"};